export const AppActionType = {
    UPDATE_CURRENT_ACT: 'APP.UPDATE_CURRENT_ACT',
    UPDATE_OPEN_CLOSE_MENU: 'MENU.UPDATE',
    UPDATE_OPEN_CLOSE_TIMELINE: 'TIMELINE.UPDATE',
    UPDATE_OPEN_CLOSE_CONTACT: 'CONTACT.UPDATE',
    UPDATE_HIDDEN_SHOW_CLOSE_BUTTON: 'CLOSE.UPDATE',
    UPDATE_OPEN_CLOSE_RECEPTION: 'RECEPTION.UPDATE',
    UPDATE_OPEN_CLOSE_HELP: 'HELP.UPDATE',
    UPDATE_OPEN_CLOSE_MAP: 'MAP.UPDATE',
    UPDATE_LANGUAGE: 'APP.UPDATE_LANGUAGE',
    UPDATE_OPEN_CLOSE_VIDEO: 'VIDEO.UPDATE',
    UPDATE_LOADING: 'LOADING.UPDATE',
    SET_VISITED: 'APP.SET_VISITED'
}
